import { Injectable } from "@angular/core";
import { HttpHeaders } from "@angular/common/http";

import { CookieService } from "ngx-cookie";

@Injectable()
export abstract class AbstractService {
    constructor(protected cookieService: CookieService) {}

    protected addAuthHeaders(): { headers: HttpHeaders } {
        const apiTokenHeader = this.cookieService.get("token");
        const headers = new HttpHeaders({
            Authorization: `Bearer ${apiTokenHeader}`,
        });

        return { headers };
    }
}
